export { SendFax as EFSendFax } from './SendFax';
